import { IMG } from "@/lib/brand";
import { PageHero, Reveal, SectionEyebrow, HexIcon } from "@/components/Section";
import { HexWatermark } from "@/components/BrandMark";
import { useLang } from "@/lib/LanguageContext";

export default function Innovation() {
  const { t } = useLang();
  const n = t.innovation;

  return (
    <div data-testid="innovation-page" className="bg-white">
      <PageHero
        testId="innovation-hero"
        eyebrow={n.hero_eyebrow}
        title={n.hero_title}
        intro={n.hero_intro}
        image={IMG.lab1}
      />

      <section className="container-x py-24 sm:py-32 grid lg:grid-cols-12 gap-12 items-center">
        <div className="lg:col-span-6 img-zoom border border-border aspect-[4/3]">
          <img src={IMG.microscope} alt="Microscope" className="w-full h-full object-cover" />
        </div>
        <div className="lg:col-span-6">
          <SectionEyebrow>{n.phil_eyebrow}</SectionEyebrow>
          <h2 className="mt-5 font-display text-4xl sm:text-5xl tracking-tight font-medium leading-[1.05]">{n.phil_title}</h2>
          <p className="mt-6 text-muted-foreground text-lg leading-relaxed">{n.phil_intro}</p>
        </div>
      </section>

      <section className="bg-secondary border-y border-border">
        <div className="container-x py-24 sm:py-32">
          <SectionEyebrow>{n.cap_eyebrow}</SectionEyebrow>
          <h2 className="mt-5 font-display text-4xl sm:text-5xl tracking-tight font-medium leading-[1.05] max-w-3xl">{n.cap_title}</h2>

          <div className="mt-16 grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-px bg-border border border-border">
            {n.capabilities.map((c, i) => (
              <Reveal key={c.title} delay={i * 0.04}>
                <div data-testid={`innovation-cap-${i}`} className="bg-secondary p-8 sm:p-10 h-full">
                  <HexIcon className="text-accent">
                    <span className="text-accent font-display font-medium">{String(i + 1).padStart(2, "0")}</span>
                  </HexIcon>
                  <h3 className="mt-6 font-display text-xl font-medium tracking-tight">{c.title}</h3>
                  <p className="mt-3 text-muted-foreground leading-relaxed">{c.desc}</p>
                </div>
              </Reveal>
            ))}
          </div>
        </div>
      </section>

      <section className="relative container-x py-24 sm:py-32 overflow-hidden">
        <HexWatermark
          opacity={0.04}
          size={640}
          strokeWidth={1.2}
          className="text-primary -right-44 top-12"
        />
        <div className="relative grid lg:grid-cols-12 gap-12 items-center">
          <div className="lg:col-span-5">
            <SectionEyebrow>{n.method_eyebrow}</SectionEyebrow>
            <h3 className="mt-5 font-display text-3xl sm:text-4xl tracking-tight font-medium leading-[1.05]">{n.method_title}</h3>
            <p className="mt-6 text-muted-foreground leading-relaxed">{n.method_intro}</p>
          </div>
          <div className="lg:col-span-7 grid grid-cols-2 gap-px bg-border border border-border">
            {n.stats.map(([num, l]) => (
              <div key={l} className="bg-white p-8">
                <div className="font-display text-4xl tick tracking-tight text-primary">{num}</div>
                <div className="mt-2 text-[11px] tracking-[0.22em] uppercase text-muted-foreground">{l}</div>
              </div>
            ))}
          </div>
        </div>
      </section>
    </div>
  );
}
